import ShopServiceModel from '@/models/ShopServiceModel';
import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';

@model.urnResource('stonecode_file_source')
@doc.path('/stonecode_file_sources/{?id}')
export default class SourceModel extends ShopServiceModel {
	private declare _tsFilters: {
		'entityUrn': string;
	};

	private declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare entityUrn: Urn;
}